import FlowsConfigMobileToolbar from '@flows/src/components/flows-configure/FlowsConfigMobileToolbar';
import FLowsConfigToolbarContent from '@flows/src/components/flows-configure/FLowsConfigToolbarContent';
import FlowsConfigureCompanies from '@flows/src/components/flows-configure/FlowsConfigureCompanies';
import FlowsConfigureCoveragesWrapper from '@flows/src/components/flows-configure/FlowsConfigureCoveragesWrapper';
import FlowsConfigureFinishWrapper from '@flows/src/components/flows-configure/FlowsConfigureFinishWrapper';
import FlowsConfigureInsurances from '@flows/src/components/flows-configure/FlowsConfigureInsurances';
import FlowsConfigureYellowhiveProducts from '@flows/src/components/flows-configure/FlowsConfigureYellowhiveProducts';
import AdvisoryAppShell from '@flows/src/components/ui/advisory-flow/components/app-shell/AdvisoryAppShell';
import { useAnvaFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/anvaFlowsConfigureStore';
import { useYellowhiveFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/yellowhiveFlowsConfigureStore';
import { ErrorBoundary } from '@sentry/react';
import { FC, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router';

export const FLOWS_CONFIG_PATH = '/flow-config';

const FlowsConfigRouter: FC = () => {
  const resetAnva = useAnvaFlowsConfigureStore((state) => state.resetStore);
  const resetYellowhive = useYellowhiveFlowsConfigureStore(
    (state) => state.resetStore,
  );

  useEffect(() => {
    resetAnva();
    resetYellowhive();
    return () => {
      resetAnva();
      resetYellowhive();
    };
  }, []);

  return (
    <ErrorBoundary>
      <AdvisoryAppShell
        toolbarContent={<FLowsConfigToolbarContent />}
        mobileToolbarContent={<FlowsConfigMobileToolbar />}
      >
        <Switch>
          <Redirect
            from={`${FLOWS_CONFIG_PATH}/:flowId`}
            to={{
              pathname: `${FLOWS_CONFIG_PATH}/:flowId/insurances`,
              search: window.location.search,
            }}
            exact
          />
          <Route
            path={`${FLOWS_CONFIG_PATH}/:flowId/insurances`}
            component={FlowsConfigureInsurances}
            exact
          />
          <Route
            path={`${FLOWS_CONFIG_PATH}/:flowId/insurances/:insuranceId/coverages`}
            component={FlowsConfigureCoveragesWrapper}
          />
          {/* anva products only */}
          <Route
            path={`${FLOWS_CONFIG_PATH}/:flowId/insurances/:insuranceId/companies`}
            component={FlowsConfigureCompanies}
          />
          {/* yellowhive products only */}
          <Route
            path={`${FLOWS_CONFIG_PATH}/:flowId/products`}
            component={FlowsConfigureYellowhiveProducts}
          />
          <Route
            path={`${FLOWS_CONFIG_PATH}/:flowId/finish`}
            component={FlowsConfigureFinishWrapper}
          />
        </Switch>
      </AdvisoryAppShell>
    </ErrorBoundary>
  );
};

export default FlowsConfigRouter;
